import { Redirect, useRouteMatch } from 'react-router-dom';
import {get} from 'lodash';
import {useSelector} from 'react-redux';
import React, {useState} from 'react';
import resolvePath from '../../misc/resolvePath';

const HasData = props => {
    const {path, check, children, to = resolvePath(app.history.location.pathname, '..'), logMessage, warningMessage, errorMessage} = props,
        value = useSelector(state => (check ? check(state) : get(state, path))),
        matchedRoute = useRouteMatch();

    if (value) {
        return children;
    } else {
        if (logMessage) console.log(logMessage);
        else if (warningMessage) console.warn(warningMessage);
        else if (errorMessage) console.warn(errorMessage);
        else console.warn('Data not found in state', path || check);
        console.log('At', matchedRoute);

        if ('alt' in props) {
            console.log('Showing alternative content');
            return alt;
        } else {
            console.log('Redirecting to', to);
            return <Redirect to={to} />;
        }
    }
};

export default HasData;
